<template>
  <v-flex mt-5 class="customer-badge" v-if="customerNumber">
    <v-btn large class="white--text" color="#08107b" to="/switch_customer">
      Not
      <span class="customer-switch-layout">
        {{ customerName }}
      </span>
      <span class="customer-switch-layout-division">
        ({{ customerNumber }} > {{ customerDivisionLabel }})
      </span>
      ? Switch customer&nbsp;
      <v-icon small>launch</v-icon>
    </v-btn>
  </v-flex>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: mapGetters("customer", {
    customerNumber: "getNumber",
    customerName: "getName",
    customerDivisionLabel: "getDivisionLabel"
  })
};
</script>
